import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deletePreviousApprovalNote,
  getWorkflowCase,
  listWorkflowCases,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 「前回承認時の申し送り」(= 差戻し後に保持される承認メモ) を削除する
 * mutation hook (workflow-fix-approval-ux Design Note Decision #3)。
 * onSuccess で detail + list query を invalidate する。
 */
export function useDeletePreviousApprovalNote(
  caseId: string,
): InvalidatingMutationResultFor<typeof deletePreviousApprovalNote> {
  return useInvalidatingMutation(deletePreviousApprovalNote, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
